import { Component, OnInit, Input, AfterViewInit, ViewChild, EventEmitter, Output } from '@angular/core';
import { AssetsGridComponent } from '../assets-grid/assets-grid.component';
import { EquipmentTypeSelectorComponent } from '../equipment-type-selector/equipment-type-selector.component';
import { EquipmentSelectorComponent } from '../equipment-selector/equipment-selector.component';
import { AllPointsComponent } from '../all-points/all-points.component';
import * as _ from 'lodash';
import { RenameAssetComponent } from '../rename-asset/rename-asset.component';
import { Location } from '../../context-discovery-services/models/location.model';
import { ConfigurePointComponent } from '../configure-point/configure-point.component';
import { ContextDiscoveryEventBusService } from '../../context-discovery-services/services/context-discovery-event-bus.service';
import { PointService, SiteService, AssetService, RoleService, SpatialAssetService } from '../../context-discovery-services/services';
import { FeatureFlags } from '../../context-discovery-services/constants/feature-flags.const';
import { Point } from '../../context-discovery-services/models/point.model';
import { Asset } from '../../context-discovery-services/models/asset.model';
import { Equipment } from '../../context-discovery-services/models/equipment.model';
import { Message } from '../../context-discovery-services/models/message.model';
import { SeverityType } from '../../context-discovery-services/constants/severity-type.const';
import { CreateAsset } from '../../context-discovery-services/models/create-asset.model';
import { RenameAsset } from '../../context-discovery-services/models/rename-asset.model';
import { ConfigurePoint } from '../../context-discovery-services/models/configure-point.model';
import { LaunchDarklyService } from '../../context-discovery-services/services/launch-darkly.service';

@Component({
  selector: 'adminapp-widget',
  templateUrl: './widget.component.html',
  styleUrls: ['./widget.component.scss']
})
export class WidgetComponent implements AfterViewInit, OnInit {

  private _modelId: any;
  private _equipmentIriInContext: string;
  pointList: Array<Point>;
  assetList: Array<Asset>;
  listOfAssets: Array<Asset>;
  listOfConfirmedAssets: Array<Asset>;
  listOfUnconfirmedAssets: Array<Asset>;
  listOfTypesOfEquipments: Array<Equipment>;
  pointRoles: any;
  viewSelector: any;
  listOfAllAssets: Asset[];
  allPoints: any[];
  allAssetsPointViewSelector: any;
  isGetAllAssetsInProgress: boolean;
  isGetAssetsInProgress: boolean;
  isGetAllPointsInProgress: boolean;
  assetsList: Asset[];
  assetFilterDelegate: any;
  pointFilterDelegate: any;
  @ViewChild(AssetsGridComponent) assetsGridComponent: AssetsGridComponent;
  @ViewChild(AllPointsComponent) allPointsComponent: AllPointsComponent;
  @ViewChild(EquipmentTypeSelectorComponent) equipmentTypeSelectorComponent: EquipmentTypeSelectorComponent;
  @ViewChild('regroupAssetsSelector') regroupAssetsEquipmentSelector: EquipmentSelectorComponent;
  @ViewChild('movePointsToOptionSelector') movePointsToOptionSelector: any;
  @ViewChild('addPointsToAsset') addPointsToAsset: any;
  @ViewChild('createNewAsset') createNewAsset: any;
  @ViewChild('regroupAssetsDialog') regroupAssetsDialog: any;
  @ViewChild('renameAsset') renameAsset: RenameAssetComponent;
  @ViewChild('assignLocationDialog') assignLocationDialog: any;
  @ViewChild('assignPointRoleDialog') assignPointRoleDialog: ConfigurePointComponent;
  innerTabChangedCallback: any;
  countOfAssetsSelectedForRegroup: number;
  labelOfRegroupAssetsEquipmentSelected: string;
  identifyAssetsMasterLoading: boolean = false;
  launchDarklySubscription: any;
  canUserAssignPropertyRolesFromIdentifyAssets: boolean;
  canUserAssignLocation: boolean;

  @Output()
  widgetToLayoutEventEmitter: EventEmitter<any> = new EventEmitter<any>();

  @Input()
  set equipmentIriInContext(assetIri: string) {
    if (this._equipmentIriInContext !== assetIri) {
      this._equipmentIriInContext = assetIri;
      this.setEquipmentSelectedInEquipmentTypeSelector();
    }
  }

  @Input()
  set modelId(idOfModel: string) {
    if (this._modelId === idOfModel) {
      return;
    }
    this._modelId = idOfModel;
    if (this._modelId) {
      this.initialize();
    }
  }

  constructor(private siteService: SiteService, private assetService: AssetService,
    private roleService: RoleService, private eventBusService: ContextDiscoveryEventBusService,
    private pointService: PointService, private spatialAssetService: SpatialAssetService, private ldService: LaunchDarklyService) {

    this.canUserAssignPropertyRolesFromIdentifyAssets = this.ldService.
      getBooleanFeatureFlagValue(FeatureFlags.ASSIGN_PROPERTY_ROLE_FROM_IDENTIFY_ASSETS);
    this.canUserAssignLocation = this.ldService.getBooleanFeatureFlagValue(FeatureFlags.ASSIGN_LOCATION_FROM_IDENTIFY_ASSETS);
    this.launchDarklySubscription = this.ldService.flagChange.subscribe(_ => {
      this.canUserAssignPropertyRolesFromIdentifyAssets = this.ldService.
        getBooleanFeatureFlagValue(FeatureFlags.ASSIGN_PROPERTY_ROLE_FROM_IDENTIFY_ASSETS, true);
      this.canUserAssignLocation = this.ldService.getBooleanFeatureFlagValue(FeatureFlags.ASSIGN_LOCATION_FROM_IDENTIFY_ASSETS, true);
    });

    this.eventBusService.serverMessage$.subscribe((message: Message) => {
      const identifyAssetsToast: any = document.getElementById(message.severityType + 'IdentifyAssets');
      identifyAssetsToast.text = message.content;
      identifyAssetsToast.open();
    });
  }

  ngOnInit(): void {
  }

  ngAfterViewInit(): void {
    this.viewSelector = document.getElementById('viewSelector');
    this.allAssetsPointViewSelector = document.getElementById('allAssetsPointViewSelector');
    if (this.regroupAssetsDialog) {
      this.regroupAssetsDialog.nativeElement.addEventListener('iron-overlay-closed', this.onRegroupAssetsDialogClosed.bind(this));
    }
    if (this.movePointsToOptionSelector) {
      this.movePointsToOptionSelector.nativeElement.addEventListener('value-changed', this.onMovePointsToOptionSelected.bind(this));
    }
    if (this.viewSelector) {
      this.viewSelector.addEventListener('selected-changed', this.onOuterTabChanged.bind(this));
    }
    if (this.allAssetsPointViewSelector) {
      this.innerTabChangedCallback = this.onInnerTabChanged.bind(this);
      this.allAssetsPointViewSelector.addEventListener('selected-changed', this.innerTabChangedCallback);
    }
  }

  onOuterTabChanged() {
    this.assetsList = this.getAssetsToPopulate();
    if (this.assetsGridComponent) {
      this.assetsGridComponent.unselectAll();
    }
  }

  onInnerTabChanged() {
    if (!this.allPointsComponent.isRefreshColumnsCalled) {
      this.allPointsComponent.refreshColumns();
    } else {
      this.allAssetsPointViewSelector.removeEventListener('selected-changed', this.innerTabChangedCallback);
    }
  }


  initialize() {
    this.isGetAssetsInProgress = true;
    this.isGetAllAssetsInProgress = true;
    this.isGetAllPointsInProgress = true;
    this.siteService.listEquipments(this._modelId).subscribe(this.getEquipmentSuccessCallBack.bind(this));
    this.assetService.listAllAssets(this._modelId).subscribe(this.getAllAssetsSuccessCallBack.bind(this));
    this.pointService.listAll(this._modelId).subscribe(this.getAllPointsSuccessCallBack.bind(this));
  }

  getRolesAndOpenDialog(pointName: string, pointIri: string) {
    this.showMasterLoadingAnimation();
    this.roleService.fetchWithoutPointsCount(this._modelId).subscribe(this.getPointRolesSuccessCallBack.bind(this, pointName, pointIri),
      this.getPointRolesFailureCallback.bind(this));
  }

  getPointRolesSuccessCallBack(pointName: string, pointIri: string, pointRoles: any) {
    pointRoles = pointRoles.map(role => ({
      label: role.label
    }))
      .sort((role1, role2) => {
        role1 = role1.label.toUpperCase();
        role2 = role2.label.toUpperCase();
        return (role1 < role2) ? -1 : (role1 > role2) ? 1 : 0;
      });
    this.pointRoles = pointRoles;
    this.stopMasterLoadingAnimation();
    this.openConfigurePointsDialog(pointName, pointIri);
  }

  getPointRolesFailureCallback(error: any) {
    console.log('Unable to fetch point roles: ', error);
    this.assetsOperationErrorCallback('Something went wrong.');
  }

  getEquipmentSuccessCallBack(equipments: Array<Equipment>) {
    this.listOfTypesOfEquipments = equipments;
    this.setEquipmentSelectedInEquipmentTypeSelector();
  }

  getAllAssetsSuccessCallBack(assets: Array<Asset>) {
    this.isGetAllAssetsInProgress = false;
    this.listOfAllAssets = assets;
    this.onOuterTabChanged();
  }

  getAllPointsSuccessCallBack(points: Array<Point>) {
    this.isGetAllPointsInProgress = false;
    this.allPoints = points;
    this.pointList = this.setPointsToPopulate();
  }

  onEquipmentSelected(selectedEquipmentIri) {
    if (selectedEquipmentIri) {
      this._equipmentIriInContext = selectedEquipmentIri;
      this.isGetAssetsInProgress = true;
      this.assetService.listAssets(this._modelId, selectedEquipmentIri).subscribe(this.getAssetsSuccessCallback.bind(this));
    }
  }

  onMovePointsToOptionSelected(event: any) {
    if (this.allPointsComponent.getSelectedItems().length === 0) {
      this.eventBusService.sendMessage(new Message('Please select some points', SeverityType.INFORMATION));
    } else {
      switch (event.detail.value) {
        case 'newAsset':
          this.createNewAsset.open(this.equipmentTypeSelectorComponent.getSelectedValue());
          break;
        case 'existingAsset':
          this.addPointsToAsset.open(this.equipmentTypeSelectorComponent.getSelectedValue());
          break;
      }
    }

    setTimeout(() => {
      this.movePointsToOptionSelector.nativeElement.value = null;
      this.movePointsToOptionSelector.nativeElement._markOption(null, false);
    }, 0);
  }

  onAssetSelected(selectedIri: string) {
    const selectedPoints = this.allPointsComponent.getSelectedItems();
    this.isGetAllAssetsInProgress = true;
    this.isGetAssetsInProgress = true;
    this.isGetAllPointsInProgress = true;
    this.pointService.movePoints(this._modelId, selectedIri, selectedPoints).
      subscribe(this.assetsOperationSuccessCallback.bind(this, 'Points are added to asset successfully'),
        this.handleMoveErrorStatus.bind(this));
  }

  onAssetCreated(createAssetModel: CreateAsset) {
    this.isGetAllAssetsInProgress = true;
    this.isGetAssetsInProgress = true;
    this.isGetAllPointsInProgress = true;
    this.assetService.create(this._modelId, createAssetModel.equipmentTypeIri, createAssetModel.newAssetName).
      subscribe(this.createAssetSuccessCallback.bind(this), this.createAssetFailureCallback.bind(this));
  }

  createAssetSuccessCallback(createdAsset: any) {
    this.eventBusService.sendMessage(new Message('Asset ' + _.escape(createdAsset.label) + ' has been created successfully',
      SeverityType.SUCCESS));
    this.onAssetSelected(createdAsset.id);
  }

  createAssetFailureCallback(error) {
    this.isGetAllPointsInProgress = false;
    if (error.status !== 500) {
      this.assetsOperationErrorCallback('Create asset failed. Please try again');
    }
  }

  onMoveAssets() {
    this.regroupAssets(this.equipmentTypeSelectorComponent.getSelectedValue(), 'Assets Moved');
  }

  onRegroupAssetsDialogOkClicked() {
    if (this.regroupAssetsDialog) {
      this.regroupAssetsDialog.okClicked();
    }
  }

  onRegroupAssetsDialogClosed() {
    if (this.regroupAssetsEquipmentSelector) {
      this.regroupAssetsEquipmentSelector.reset();
    }
  }

  regroupAssets(selectedEquipmentIri, successMessage) {
    this.isGetAllAssetsInProgress = true;
    this.isGetAssetsInProgress = true;
    this.isGetAllPointsInProgress = true;
    this.assetService.regroup(this._modelId, selectedEquipmentIri, this.assetsGridComponent.getSelectedItems()).
      subscribe(this.assetsOperationSuccessCallback.bind(this, successMessage), this.handleRegroupingErrorStatus.bind(this));
  }

  onRegroupAssets(selectedEquipmentIri) {
    if (selectedEquipmentIri) {
      if (this.regroupAssetsDialog) {
        this.countOfAssetsSelectedForRegroup = this.assetsGridComponent.getSelectedItems().length;
        this.labelOfRegroupAssetsEquipmentSelected = this.regroupAssetsEquipmentSelector.getSelectedDisplayedValue();
        this.regroupAssetsDialog.nativeElement.open();
        this.regroupAssetsDialog.okClicked = () => {
          this.regroupAssets(selectedEquipmentIri, 'Assets Regrouped');
        };
      }
    }
  }

  handleMoveErrorStatus(error) {
    this.isGetAllPointsInProgress = false;
    if (error.status !== 500) {
      this.assetsOperationErrorCallback('Points moved failed. Please try again');
    }
  }

  handleRegroupingErrorStatus(error) {
    if (error.status === 403) {
      this.assetsOperationErrorCallback('Please check for duplicate points across assets selected');
    } else if (error.status === 413) {
      this.assetsOperationErrorCallback('Too many assets are selected.' +
        ' Please select fewer assets and try again.');
    } else {
      this.assetsOperationErrorCallback('Something went wrong. Please try again');
    }
  }

  getAssetsSuccessCallback(assets: Array<Asset>) {
    this.isGetAssetsInProgress = false;
    this.listOfAssets = assets;
    this.listOfConfirmedAssets = assets.filter(asset => asset.confirmed);
    this.listOfUnconfirmedAssets = assets.filter(asset => !asset.confirmed);
    if (!this.viewSelector.selected) {
      this.viewSelector.selected = 0;
    } else {
      switch (this.viewSelector.selected) {
        case '0': this.viewSelector.selected = 0; return;
        case '1': this.viewSelector.selected = 1; return;
        case '2': this.viewSelector.selected = 2; return;
      }
    }
    this.onOuterTabChanged();
  }

  setPointsToPopulate(): Array<Point> {
    if (this.pointFilterDelegate) {
      return this.allPoints.filter(this.pointFilterDelegate);
    } else {
      return this.allPoints;
    }
  }


  getAssetsToPopulate(): Array<Asset> {
    if (this.viewSelector) {
      switch (this.viewSelector.selected) {
        case 0:
          if (this.assetFilterDelegate) {
            return this.listOfUnconfirmedAssets.filter(this.assetFilterDelegate);
          } else {
            return this.listOfUnconfirmedAssets;
          }
        case 1:
          if (this.assetFilterDelegate) {
            return this.listOfConfirmedAssets.filter(this.assetFilterDelegate);
          } else {
            return this.listOfConfirmedAssets;
          }
        case 2:
          if (this.assetFilterDelegate) {
            return this.listOfAllAssets.filter(this.assetFilterDelegate);
          } else {
            return this.listOfAllAssets;
          }
        default:
          return [];
      }
    }
  }

  shouldShowLoading() {
    if (!isNaN(this.viewSelector.selected) && ((this.viewSelector.selected.toString() === '0' && this.isGetAssetsInProgress) ||
      this.viewSelector.selected.toString() === '1' && this.isGetAssetsInProgress ||
      this.viewSelector.selected.toString() === '2' && this.isGetAllAssetsInProgress)) {
      return true;
    }
    return false;
  }

  confirmAssets() {
    this.isGetAllAssetsInProgress = true;
    this.isGetAssetsInProgress = true;
    this.assetService.confirm(this._modelId, this.assetsGridComponent.getSelectedItems()).
      subscribe(this.assetsOperationSuccessCallback.bind(this, 'Assets Confirmed'), this.confirmAssetsErrorCallback.bind(this));
  }

  unconfirmAssets() {
    this.isGetAllAssetsInProgress = true;
    this.isGetAssetsInProgress = true;
    this.assetService.unconfirm(this._modelId, this.assetsGridComponent.getSelectedItems()).
      subscribe(this.assetsOperationSuccessCallback.bind(this, 'Assets Unconfirmed'), this.unconfirmAssetsErrorCallback.bind(this));
  }

  assetsOperationSuccessCallback(message) {
    this.assetsGridComponent.unselectAll();
    this.allPointsComponent.unselectAll();
    this.initialize();
    this.onEquipmentSelected(this.equipmentTypeSelectorComponent.getSelectedValue());
    this.eventBusService.sendMessage(new Message(message, SeverityType.SUCCESS));
  }

  assetsOperationErrorCallback(message) {
    this.assetsGridComponent.unselectAll();
    this.allPointsComponent.unselectAll();
    this.isGetAllAssetsInProgress = false;
    this.isGetAssetsInProgress = false;
    this.eventBusService.sendMessage(new Message(message, SeverityType.CRITICAL));
  }

  confirmAssetsErrorCallback(error) {
    if (error.status === 403) {
      this.assetsOperationErrorCallback('Please check for duplicate points across assets selected');
    } else {
      this.assetsOperationErrorCallback('Could not confirm selected assets');
    }
  }

  unconfirmAssetsErrorCallback() {
    this.assetsOperationErrorCallback('Could not unconfirm selected assets');
  }

  onAssetSearchPerformed(delegate: any) {
    this.assetFilterDelegate = delegate;
    this.onOuterTabChanged();
  }

  onPointSearchPerformed(delegate: any) {
    this.pointFilterDelegate = delegate;
    this.pointList = this.setPointsToPopulate();
  }

  onAssetRenamePerformed(assetRenamedEvent: any) {
    const assetRenamed: RenameAsset = assetRenamedEvent;
    this.renameAsset.open(assetRenamed.assetIri, assetRenamed.assetName);
  }

  onAssetRenameSuccess(assetRenamedSuccessEvent: RenameAsset) {
    this.isGetAllAssetsInProgress = true;
    this.isGetAssetsInProgress = true;
    const assetIri = assetRenamedSuccessEvent.assetIri;
    const assetName = assetRenamedSuccessEvent.assetName;
    this.assetService.rename(this._modelId, assetIri, assetName)
      .subscribe(this.renameSuccessCallback.bind(this, 'Asset renamed'), this.renameFailureCallback.bind(this, 'Something went wrong'));
  }

  renameSuccessCallback(message) {
    this.assetsOperationSuccessCallback(message);
  }

  renameFailureCallback(message) {
    this.assetsOperationErrorCallback(message);
  }

  onAssignLocation() {
    if (this.assignLocationDialog) {
      this.assignLocationDialog.open(this._modelId);
    }
  }

  onLocationToBeAssignedSuccess(locationToBeAssigned: Location) {
    this.isGetAllAssetsInProgress = true;
    this.isGetAssetsInProgress = true;

    const selectedAssetIds = [];
    _.each(this.assetsGridComponent.getSelectedItems(), function (asset) {
      selectedAssetIds.push(asset.id);
    });

    this.spatialAssetService.assignLocations(this._modelId, locationToBeAssigned, selectedAssetIds)
      .subscribe(this.assignLocationSuccessCallback
        .bind(this, 'Location ' + locationToBeAssigned.label + ' is assigned to selected asset(s)'),
        this.assignLocationFailureCallback.bind(this));
  }

  assignLocationSuccessCallback(message) {
    this.assetsOperationSuccessCallback(message);
  }

  assignLocationFailureCallback(error) {
    if (error.status === 409) {
      this.assetsOperationErrorCallback('Location already exists');
    } else {
      this.assetsOperationErrorCallback('Could not assign location to selected asset(s)');
    }
  }

  onRoleAssignedToPoint(roleAssignedEvent: ConfigurePoint) {
    const pointName = roleAssignedEvent.pointName;
    const pointIri = roleAssignedEvent.pointIri;
    if (this.canUserAssignPropertyRolesFromIdentifyAssets) {
      this.getRolesAndOpenDialog(pointName, pointIri);
    } else {
      this.assetsOperationErrorCallback('Point role assignment not supported.');
    }
  }

  openConfigurePointsDialog(pointName, pointIri) {
    this.assignPointRoleDialog.open(pointName, pointIri, this.pointRoles);
  }

  showMasterLoadingAnimation() {
    this.identifyAssetsMasterLoading = true;
  }

  stopMasterLoadingAnimation() {
    this.identifyAssetsMasterLoading = false;
  }

  showLoadingAnimation() {
    this.isGetAssetsInProgress = true;
    this.isGetAllPointsInProgress = true;
  }

  stopLoadingAnimation() {
    this.isGetAssetsInProgress = false;
    this.isGetAllPointsInProgress = false;
  }

  onPointConfigured(event: any) {
    const pointIri = event.point;
    const roleLabel = event.role;
    const point = this.pointList.filter(point => {
      if (point.iri === pointIri) {
        return true;
      }
      return false;
    });
    this.showLoadingAnimation();
    this.assignRoleToPoint(point, roleLabel);
  }

  assignRoleToPoint(point, roleLabel) {
    this.pointService.assignRole(this._modelId, roleLabel, point)
      .subscribe(this.configurePointSuccessCallback.bind(this, 'Point configured.'),
        this.configurePointFailureCallback.bind(this, 'Something went wrong'));

  }

  configurePointSuccessCallback(message) {
    this.stopLoadingAnimation();
    this.assetsOperationSuccessCallback(message);
  }

  configurePointFailureCallback(message) {
    this.stopLoadingAnimation();
    this.assetsOperationErrorCallback(message);
  }

  onAssigningRoleToUnconfirmedAsset() {
    const message = 'Please confirm the asset to assign property role.';
    this.assetsOperationErrorCallback(message);
  }

  handlePublishEvent(event) {
    this.showMasterLoadingAnimation();
    const timezone = event.timezone;
    this.siteService.publishWithAnalytics(this._modelId, true, timezone).subscribe(this.publishStartedSuccessCallback.bind(this),
      this.publishStartedFailureCallback.bind(this));
  }

  publishStartedSuccessCallback() {
    this.stopMasterLoadingAnimation();
    this.widgetToLayoutEventEmitter.emit({
      eventType: 'PUBLISH'
    });
  }

  publishStartedFailureCallback() {
    this.stopMasterLoadingAnimation();
    this.assetsOperationErrorCallback('Unable to start publish');
  }

  private setEquipmentSelectedInEquipmentTypeSelector() {
    if (!!this._equipmentIriInContext) {
      this.equipmentTypeSelectorComponent.setSelectedValue(this._equipmentIriInContext);
    }
  }
}
